export const platformURLs = {
  video: ['twitch.tv', 'youtube.com', 'youtu.be', 'vimeo.com'],
  podcast: ['podcasts.apple.com', 'spotify.com/show', 'spotify.com/episode'],
  notionDoc: ['notion.so'],
  spreadsheet: ['docs.google.com/spreadsheets'],
  airtable: ['airtable.com'],
  wordDoc: ['docs.google.com/document'],
  article: ['medium.com', 'substack.com'],
  social: [
    'instagram.com',
    'facebook.com',
    'pinterest.com',
    'snapchat.com',
    'twitter.com',
    'linkedin.com',
    'tiktok.com',
  ],
  product: ['liketoknow.it', 'liketk.it'],
}
